export default {
  confirmarConta: {
    aguarde: "Please wait, we are creating your account",
    falhaAoCarregarDados: "Failed to create account",
    confirmacao:
      "Your account is ready. You will receive an email to create your password"
  }
};
